// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { ErrorAlert } from 'ui_kit_qmd'
import closeIcon from '../../../images/common/close.png'
import errorIcon from '../../../images/common/error-icon.svg'
import { clearError } from '../../../store/patient-side-panel/PatientSidePanelActions'
import { createVisitRemarks } from '../../../store/patient-side-panel/PatientSidePanelThunk'
import { RemarksContent } from './RemarksContent'
import { AddVisitRemark } from '../AddVisitRemark'
import './VisitRemarks.scss'
import { emojiRegex, getTabId } from '../../../utils/common'

const alertContainer = { width: 500, left: '-190px' }

export const VisitRemarks = ({
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  remarks,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  loading,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  close,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  isNeedToResetRemarksInputError,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setIsNeedToResetRemarksInputError,
}) => {
  const tabId = getTabId()
  const dispatch = useDispatch()
  const addSidePanelItemInputRef = useRef()
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const error = useSelector((state) => state.patientSidePanel.error)

  const [newVisitRemarkText, setNewVisitRemarkText] = useState('')

  const remarksContainerRef = useRef(null)
  const scrollTo = useRef(null)

  const { remarksList } = remarks || {}

  useEffect(() => {
    if (error) {
      setTimeout(() => {
        dispatch(clearError())
      }, 3500)
    }
  }, [error])

  const onAddNewVisitRemarks = () => {
    if (newVisitRemarkText) {
      dispatch(
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        createVisitRemarks({
          visitId: remarks.visitId,
          Message: newVisitRemarkText.trim().replaceAll('<br>', '\n'),
          tabId,
          isForceUpdate: false,
        }),
      )
      setNewVisitRemarkText('')
      if (document.getElementById('addNewRemarkTextField')) {
        // @ts-expect-error TS2531 -- MIGRATION: not approved, fix when encountered
        document.getElementById('addNewRemarkTextField').innerText = ''
      }
    }
  }

  const setCaret = () => {
    const el = document.getElementById('addNewRemarkTextField')
    const range = document.createRange()
    const sel = window.getSelection()
    // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
    const childNodesListLength = el.childNodes?.length

    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    range.setStart(el?.childNodes?.[childNodesListLength - 1], el?.childNodes?.[childNodesListLength - 1]?.length)
    range.collapse(true)

    // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
    sel.removeAllRanges()
    // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
    sel.addRange(range)
  }

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onChangeNewVisitRemarksInputValue = (e) => {
    if (
      (document.getElementById('addNewRemarkTextField') &&
        !e.currentTarget.innerHTML.split('<div><br></div>').join('')) ||
      !e.currentTarget.innerHTML.split('<br>').join('')
    ) {
      // @ts-expect-error TS2531 -- MIGRATION: not approved, fix when encountered
      document.getElementById('addNewRemarkTextField').innerText = ''
      setNewVisitRemarkText('')
    } else {
      const baseInner = e.currentTarget.innerHTML.split('<div><br></div>').join('')
      const baseInnerWithoutEmoji = e.currentTarget.innerHTML
        .replaceAll(emojiRegex, '')
        .split('<div><br></div>')
        .join('')

      if (baseInner.length === baseInnerWithoutEmoji.length) {
        setNewVisitRemarkText(e.currentTarget.innerHTML.split('<div><br></div>').join(''))
      } else {
        setNewVisitRemarkText((prev) => prev)
        // @ts-expect-error TS18048 -- MIGRATION: not approved, fix when encountered
        addSidePanelItemInputRef.current.innerHTML = baseInnerWithoutEmoji
        setCaret()
      }
    }
  }

  useEffect(() => {
    if (remarksList?.length && scrollTo.current) {
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      scrollTo.current.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
    }
  }, [remarksList])

  return (
    <>
      {!!error && <ErrorAlert errorText={error} errorImg={errorIcon} imgAlt='Error' styleContainer={alertContainer} />}

      <div ref={remarksContainerRef} className='remarks-container'>
        <div className='remarks-head'>
          <div className='remarks-title'>Visit remarks</div>
          <img role='presentation' alt='Close' src={closeIcon} className='remarks-close-icon' onClick={close} />
        </div>
        <div className='remarks-body'>
          <div className='remarks-content'>
            <RemarksContent remarks={remarks} />
            <div ref={scrollTo} />
            {!remarks?.remarksList?.length && !loading ?
              <div className='remarks-message remarks-message-center'>No visit remarks for this visit yet</div>
            : null}
          </div>
          <div className='add-remark'>
            <AddVisitRemark
              // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
              addPressCallback={onAddNewVisitRemarks}
              inputValue={newVisitRemarkText}
              onChangeInputValue={onChangeNewVisitRemarksInputValue}
              addSidePanelItemInputRef={addSidePanelItemInputRef}
              visitId={remarks.visitId}
              isNeedToResetRemarksInputError={isNeedToResetRemarksInputError}
              setIsNeedToResetRemarksInputError={setIsNeedToResetRemarksInputError}
            />
          </div>
        </div>
      </div>
    </>
  )
}
